import * as branding from './ducks/branding'
import * as builder from './ducks/builder'
import * as customers from './ducks/customers'
import * as dates from './ducks/dates'
import * as employees from './ducks/employees'
import * as exporter from './ducks/exporter'
import * as externalLinks from './ducks/externalLinks'
import * as flags from './ducks/flags'
import * as i18n from './ducks/i18n'
import * as integrations from './ducks/integrations'
import * as licenses from './ducks/licenses'
import * as meta from './ducks/meta'
import * as reports from './ducks/reports'
import * as sessionModal from './ducks/sessionModal'
import * as subheader from './ducks/subheader'
import * as table from './ducks/table'
import * as uploads from './ducks/uploads'
import * as user from './ducks/user'
import * as userPermissions from './ducks/userPermissions'

/**
 * Reexports
 */
export { default as I18nProvider } from './i18n/I18nProvider'
export * from './layout/LayoutConfig'
export { default as LayoutConfig } from './layout/LayoutConfig'
export * from './layout/LayoutContext'
export { default as LayoutInitializer } from './layout/LayoutInitializer'
export { default as ThemeProvider } from './materialUIThemeProvider/ThemeProvider'
export * from './utils/utils'

/**
 * Ducks
 */
export const augmentt = {
  i18n,
  customers,
  licenses,
  user,
  dates,
  employees,
  branding,
  builder,
  uploads,
  flags,
  integrations,
  exporter,
  meta,
  externalLinks,
  reports,
  sessionModal,
  userPermissions,
  table,
  subheader,
}
